import * as React from 'react';
import MainWaterBill from '../../components/bill/water/MainWaterBill';
import { useNavigate } from 'react-router-dom';
import Storage from '../../services/Storage';

export default function WaterBill() {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (Storage.getLocalAccessToken() === null) {
      navigate('/signin', { replace: true })
    }
  }, [navigate])
  return (
    <MainWaterBill></MainWaterBill>
  );
}